import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../data/site";

export const LanguageSwitcher = ({ variant = "dark" }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  const isDark = variant === "dark";

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        data-testid="language-switcher-trigger"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-2 rounded-full border px-3.5 py-2 text-sm font-medium transition-colors ${
          isDark
            ? "border-white/25 text-white hover:bg-white/10"
            : "border-purpleink/20 text-purpleink hover:bg-purpleink/5"
        }`}
      >
        <Globe className="h-4 w-4" />
        <span className="hidden sm:inline">{current.label}</span>
        <span className="sm:hidden">{current.code.toUpperCase()}</span>
        <ChevronDown
          className={`h-3.5 w-3.5 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>

      <AnimatePresence>
        {open && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setOpen(false)}
            />
            <motion.ul
              initial={{ opacity: 0, y: 8, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 8, scale: 0.97 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              className="absolute right-0 z-50 mt-2 w-52 overflow-hidden rounded-2xl border border-purpleink/10 bg-white p-1.5 shadow-2xl"
            >
              {LANGS.map((l) => (
                <li key={l.code}>
                  <button
                    data-testid={`language-option-${l.code}`}
                    onClick={() => {
                      setLang(l.code);
                      setOpen(false);
                    }}
                    className={`flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm transition-colors ${
                      lang === l.code
                        ? "bg-purpleink/8 text-purpleink font-semibold"
                        : "text-stone-700 hover:bg-stone-100"
                    }`}
                  >
                    <span className="flex items-center gap-2.5">
                      <span className="text-base">{l.flag}</span>
                      {l.label}
                    </span>
                    {lang === l.code && <Check className="h-4 w-4 text-teal" />}
                  </button>
                </li>
              ))}
            </motion.ul>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};
